<template>
  <div>
    <div class="main-wrapper signin-form center signin-wrapper-padding">
	  <div class="text-align-center margin-bottom-20 mm-logo"><img src="@/assets/MM-logo.png" /></div>
	  <h3 class="text-align-center margin-bottom-35">Forgot Password</h3>
    <div v-show="login_errors" class="validate-warning-msg-login">{{ login_errors }}</div>
      <form @submit.prevent="onSubmit">
		<div class="row margin-bottom-15">
		  <div class="col-12 col-sm-12">
			<label
					for="email"
					class="col-12">Email address : <span class="required">*</span></label>
			<input
					type="email_addr"
					name="email address"
					id="email_addr"
					class="col-12 col-sm-12 input-height-35"
					ref="email_addr"
					v-validate="'required|email'"
					v-model="email_addr">
			<div v-show="verrors.has('email address')" class="validate-warning-msg">{{ verrors.first('email address') }}</div>

		  </div>
		</div>
        <div class="submit margin-bottom-15">
          <button type="submit" class="btn btn-info btn-md" @click="validate">Submit</button>
        </div>

      </form>
    </div>
  </div>
</template>
<style scoped>
.mm-logo img { width: 240px; }
</style>
<script>
import Vue from 'vue/dist/vue.esm';
import VeeValidate from 'vee-validate';
import router from '../router/index.js';
import axios from 'axios';

Vue.use(VeeValidate, { errorBagName: 'verrors', fieldsBagName: 'vfields'});

export default {
  data: function () {
    return {
      email_addr: '',
      login_errors: '',
    }
  },
  methods: {
  	validate() {
  	  this.$validator.validateAll();
      },
  	onSubmit () {
      this.$validator.validateAll().then((result) => {
        if(!result){
          return;
        }
        this.forgotpassword();
      }).catch(() => {
        // catches the error;
      });

  	},
    navigate(path) {
  	  router.push(path);
  	},
    forgotpassword: function() {
      let email = this.email_addr;
      axios('/custom/forgot_password/' + email,
        {
          method: 'GET',
        }
      )
      .then(resp => {
        this.flash({ message: "An email was sent to your mailbox. Please check for resetting your password.", variant: 'success' });
        this.navigate('/login');
      })
      .catch(error => {
        this.login_errors = error.response.data.message;
      })
    }
  },
}
</script>



// WEBPACK FOOTER //
// src/components/forgotpassword.vue